import { AxiosResponse } from 'axios'

import { apiouvidoria } from './api'

export interface ConfiguracoesResponse {
  orgao_terceira_instancia: string
  ativar_manifestacao: boolean
  ativar_pedido: boolean
  ativar_solicitacao: boolean
  ativar_simplifique: boolean
  permitir_identificado: boolean
  permitir_sigiloso: boolean
}

export const verificarConfiguracaoAtiva = (
  tipo: 'esic' | 'manifestacao' | 'solicitacao',
): Promise<AxiosResponse> =>
  apiouvidoria.get(`/verificar_configuracoes_ativas/`, {
    params: { tipo },
  })

export const getConfiguracoesEsic = (): Promise<
  AxiosResponse<ConfiguracoesResponse>
> => apiouvidoria.get('/configuracoes/')
